import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {ConfiguracaoService} from '../configuracao/configuracao.service';
import {SecurityService} from '../service';
import {SelecionaEntidadeService} from '../service/seleciona-entidade.service';
import {SigplaniModuloEnum} from '../shared/enum/sigplani-modulo.enum';
import {UsuarioAutenticado} from '../shared';
import { PerfilCorporativoService } from '../service/perfil-corporativo.service';
import { PerfilControleService } from '../service/perfil-controle.service';


@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  usuarioAutenticado$: Observable<UsuarioAutenticado>;
  idUnicoUsuarioAutenticdo: number;
  capitalize = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());

  constructor(private readonly router: Router,
    private readonly selecionaEntidadeService: SelecionaEntidadeService,
    private readonly securityService: SecurityService,
    private readonly configuracaoService: ConfiguracaoService,
    private readonly perfilService: PerfilCorporativoService,
    private readonly perfilControleService: PerfilControleService,
  ) {
  }

  ngOnInit() {
    this.usuarioAutenticado$ = this.securityService.obterUsuarioAutenticado().pipe(
      filter((usuario) => usuario != undefined),
      map((usuario) => {
        this.idUnicoUsuarioAutenticdo = usuario.idUnico;
        usuario.nome = this.capitalize(usuario.nome, true);
        return usuario;
      })
    );

  }

  navegarRda() {
    this.securityService.alternarModulo(SigplaniModuloEnum.RDA);
    if (!this.securityService.isEntidadeSelecionada()) {
      this.selecionaEntidadeService.obterEntidadesUsuarioPorId(this.idUnicoUsuarioAutenticdo).subscribe((value) =>
        this.router.navigate(['/declaracao-rda']).then(() => {
          this.configuracaoService.carregarConfiguracoesTela().subscribe();
        })
      );
    } else {
      this.router.navigate(['/entidades/selecionar']).then(() => {
        this.configuracaoService.carregarConfiguracoesTela().subscribe();
      });
    }
  }

  navegarFiscalizacao(): void {
    this.securityService.alternarModulo(SigplaniModuloEnum.FISCALIZACAO);
    this.configuracaoService.carregarConfiguracoesTela()
      .subscribe();
  }

  navegarGerenciamento() {
    this.securityService.alternarModulo(SigplaniModuloEnum.GERENCIAMENTO);
    this.router.navigate(['/entidades/consultar']).then(() => {
      this.configuracaoService.carregarConfiguracoesTela().subscribe();
    });
  }

  navegarGerenciamentoPleito() {
    let route = '/pleitos';
    if (this.perfilControleService.isPerfilAcessoPleitoMCTI()) {
      route += '/mcti';
    }
    this.securityService.alternarModulo(SigplaniModuloEnum.GERENCIAMENTO);
    this.router.navigate([route]).then(() => {
      this.configuracaoService.carregarConfiguracoesTela().subscribe();
    });
  }

}
